// Makes the DateRangePicker able to "float" outside of the FilterPanel
// Could not find a pure CSS way to do it, that would be preferable.
import React from 'react';
import ReactDOM from 'react-dom';
import {requestAnimationFrameWithFallback} from '../utils';

class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.el = document.createElement('div');
    }

    componentDidMount() {
        this.modalRoot = document.getElementById('filter-section__button__date-picker-mount');
        this.modalRoot.appendChild(this.el);
    }

    componentWillUnmount() {
        this.modalRoot.removeChild(this.el);
    }

    render() {
        return ReactDOM.createPortal(
            this.props.children,
            this.el,
        );
    }
}

// eslint-disable-next-line react/no-multi-comp
export default class DateRangePickerSearchContainer extends React.Component {
    constructor(props) {
        super(props);
        this.dividerEl = React.createRef();
    }

    state = {
        top: 0,
    }

    componentDidMount() {
        this._isMounted = true;
        this._setTop();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    _setTop = () => {
        if (this._isMounted) {
            this.setState({
                top: this.dividerEl.current?.getBoundingClientRect().y,
            });

            requestAnimationFrameWithFallback(this._setTop);
        }
    }

    render() {
        const {top} = this.state;

        return (
            <>
                <div
                    id="filter-section__button__date-picker-mount"
                    style={top > 0 ? {
                        top,
                    } : {visibility: 'hidden'}}
                >
                    <Modal>
                        {this.props.children}
                    </Modal>
                </div>
                {/* Since the date-picker-mount is position:fixed, we want to reserve some space or else it will overlap with other elements */}
                <div
                    className="filter-section__button filter-section__button-unselected"
                    ref={this.dividerEl}
                >
                    <div>&nbsp;</div>
                </div>
                <div className="filter-section__filter-divider" />
            </>
        );
    }
}
